import SearchEvents from "./SearchEvents";
import { ShowResult } from "./Search";

export const search = (userId: string, keywords: string[]) =>
    ({
        type: SearchEvents.SearchStarted,
        userId,
        keywords,
    } as const);

export const searchComplete = (result: ShowResult[]) =>
    ({
        type: SearchEvents.SearchCompleted,
        result,
    } as const);
